export default "__VITE_ASSET__DrWVDFyM__"